// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","809":"transfer"}[chunkId] + "." + {"443":"d41f819a","809":"56e23ff7"}[chunkId] + ".js";
};